class ShippingEstimator {
  constructor() {
    this.apiUrl = 'https://ybzwe1cm43.execute-api.ap-northeast-1.amazonaws.com/prod/';
    this.zipInput = document.getElementById('shipping-zip');
    this.calculateBtn = document.getElementById('shipping-calculate-btn');
    this.resultsContainer = document.getElementById('shipping-results');
    this.cartItemsData = document.getElementById('cart-items-data');

    // 都道府県セレクトは廃止した。県コードは配送日 API が郵便番号から返す。
    this.province = null;

    if (!this.calculateBtn) return;
    this.bindEvents();
  }

  bindEvents() {
    this.calculateBtn.addEventListener('click', () => this.calculate());

    // delivery-date.js が郵便番号を引けたら県コードが分かる。そこで計算する。
    window.addEventListener('delivery-options-loaded', (e) => {
      this.province = e.detail.province_code;
      this.calculate();
    });
  }

  zipCode() {
    const s = String((this.zipInput && this.zipInput.value) || '')
      .replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
      .replace(/\D/g, '');
    return s.length === 7 ? s : '';
  }

  getCartItems() {
    try {
      const items = JSON.parse(this.cartItemsData.textContent);
      return items.map((item) => ({
        grams: item.grams,
        quantity: item.quantity,
        product_id: item.product_id,
        sku: item.sku || '',
      }));
    } catch (e) {
      return [];
    }
  }

  async calculate() {
    const province = this.province;
    if (!province) {
      this.showError('お届け先の郵便番号を入力してください。');
      return;
    }

    const items = this.getCartItems();
    if (items.length === 0) {
      this.showError('カートにアイテムがありません。');
      return;
    }

    this.showLoading();

    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          rate: {
            // postal_code を渡すとヤマトの区間表で引くので、離島の所要日数が
            // 県単位の表に潰れない (小笠原を東京都1日と案内しない)。
            destination: { province: province, postal_code: this.zipCode(), phone: '' },
            items: items,
          },
        }),
      });

      const data = await response.json();
      const rates = typeof data.rates !== 'undefined' ? data.rates : JSON.parse(data.body).rates;

      if (rates && rates.length > 0) {
        this.displayRates(rates);
        // Dispatch event for delivery date picker
        window.dispatchEvent(new CustomEvent('shipping-rates-calculated', { detail: { rates, province } }));
      } else {
        this.showError('この地域への配送オプションが見つかりませんでした。');
      }
    } catch (error) {
      this.showError('送料の計算中にエラーが発生しました。もう一度お試しください。');
    }
  }

  displayRates(rates) {
    let minPrice = Infinity;
    let minDate = null;
    rates.forEach((rate) => {
      const price = parseInt(rate.total_price) / 100;
      if (price < minPrice) minPrice = price;
      if (rate.min_delivery_date && (!minDate || rate.min_delivery_date < minDate)) minDate = rate.min_delivery_date;
    });

    const priceStr = minPrice === 0 ? '送料無料' : `\u00a5${minPrice.toLocaleString()}〜`;
    let html = `<div style="font-size:1.4rem;font-weight:600;">`;
    if (minDate) {
      html += `お届け:${this.formatDateShort(minDate)}以降、税別${priceStr}`;
    } else {
      html += priceStr;
    }
    html += '</div>';
    if (rates.some((rate) => String(rate.service_name).includes('ネコポス'))) {
      html +=
        '<div class="shipping-estimator__nekopos-note">ネコポスは着払い（代金引換）をご利用いただけません。着払いをご希望の場合は、ご注文手続きで他の配送方法をお選びください。</div>';
    }

    this.resultsContainer.innerHTML = html;
    this.resultsContainer.hidden = false;
  }

  formatDateShort(dateStr) {
    const d = new Date(dateStr);
    const days = ['日', '月', '火', '水', '木', '金', '土'];
    return `${d.getMonth() + 1}/${d.getDate()}（${days[d.getDay()]}）`;
  }

  showLoading() {
    this.resultsContainer.innerHTML = '<div class="shipping-estimator__loading">計算中...</div>';
    this.resultsContainer.hidden = false;
  }

  showError(message) {
    this.resultsContainer.innerHTML = `<div class="delivery-date-section__error">${this.escapeHtml(message)}</div>`;
    this.resultsContainer.hidden = false;
  }

  formatDateJP(dateStr) {
    const d = new Date(dateStr);
    const days = ['日', '月', '火', '水', '木', '金', '土'];
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日（${days[d.getDay()]}）`;
  }

  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.shippingEstimator = new ShippingEstimator();
});
